import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { CampanhaClienteVisualizacaoModo, campanhaClienteVisualizacaoModos } from './campanha-cliente-visualizacao-modo';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'sgt-campanha-cliente-visualizacao-modo',
    templateUrl: './campanha-cliente-visualizacao-modo.component.html',
    styleUrls: ['./campanha-cliente-visualizacao-modo.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampanhaClienteVisualizacaoModoComponent), multi: true },
    ]
})
export class CampanhaClienteVisualizacaoModoComponent {
    visualizacoesModos = campanhaClienteVisualizacaoModos;

    /** Modo de visualização */
    @Input() ngModel: number;
    /** Ao alterar a forma do contato */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Nome */
    @Input() name: string;
    /* ID */
    @Input() id: string;

    propagateChange: any = () => {};

    /** Ao selecionar a forma de contato */
    onChange(modo: CampanhaClienteVisualizacaoModo) {
        this.ngModel = modo ? modo.id : null;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
